var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Modal from "../Semantic/Modal";
import Button from "../Semantic/Button";
import DailyStats from "./DailyStats";
var StatsModal = function (props) {
    return (_jsx(Modal, __assign({ trigger: _jsx(Button, { icon: "chart bar" }, void 0), size: "mini", closeIcon: true }, { children: _jsx(Modal.Content, { children: _jsx(DailyStats, {}, void 0) }, void 0) }), void 0));
};
export default StatsModal;
